<template>
  <v-container fluid class="ma-0 pa-0 mt-3">
    <!-- Header con KPI principali -->
    <v-row class="ma-0 pa-2 mb-3">
      <v-col cols="12" md="3" v-for="(kpi, i) in schede" :key="i">
        <v-card class="elevation-2">
          <v-card-text class="pa-3">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-caption text--secondary">{{ kpi.etichetta }}</div>
                <div class="text-h5 font-weight-bold">{{ kpi.valore }}</div>
                <div class="text-caption" :class="kpi.tendenza > 0 ? 'success--text' : 'error--text'">
                  <v-icon small :color="kpi.tendenza > 0 ? 'success' : 'error'">
                    {{ kpi.tendenza > 0 ? 'trending_up' : 'trending_down' }}
                  </v-icon>
                  {{ Math.abs(kpi.tendenza) }}% vs anno precedente
                </div>
              </div>
              <v-icon size="40" color="primary">{{ kpi.icona }}</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filtri Dashboard -->
    <v-card class="elevation-2 mb-3">
      <v-card-title class="py-2">
        <v-select v-model="filtriGrafici.anno" :items="anniDisponibili" label="Anno" dense hide-details
          style="max-width: 120px;" class="mr-3" @change="caricaTuttiDati" />
        <v-switch v-model="filtriGrafici.soloDaFatturare" label="Solo ore da fatturare" dense hide-details
          class="mt-0 mr-4" @change="caricaTuttiDati" />

        <!-- Switch Ore/Importi -->
        <v-divider vertical class="mx-3" />
        <!-- <span class="text-caption mr-2">Visualizza:</span> -->
        <!-- <v-btn-toggle v-model="modalitaVisualizzazione" mandatory dense @change="cambiaModalita">
          <v-btn small value="importi">
            <v-icon left small>euro_symbol</v-icon>
            Importi €
          </v-btn>
          <v-btn small value="ore">
            <v-icon left small>schedule</v-icon>
            Ore
          </v-btn>
        </v-btn-toggle> -->

        <v-spacer />
        <v-btn icon small @click="caricaTuttiDati">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>

    <!-- Tabs per diverse visualizzazioni -->
    <v-tabs v-model="tabAttiva" background-color="primary" dark>
      <v-tab>
        <v-icon left>show_chart</v-icon>
        Andamento
      </v-tab>
      <v-tab>
        <v-icon left>pie_chart</v-icon>
        Composizione
      </v-tab>
      <v-tab>
        <v-icon left>compare_arrows</v-icon>
        Confronti
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabAttiva" class="mt-3">
      <!-- Tab 1: Andamento -->
      <v-tab-item>
        <tab-andamento-ore :filtri="filtriGrafici" :modalita="modalitaVisualizzazione" :aggiornaDati="aggiornaDati"
          @caricaDati="caricaDatiKPI" />
      </v-tab-item>

      <!-- Tab 2: Composizione -->
      <v-tab-item>
        <tab-composizione-ore :filtri="filtriGrafici" :modalita="modalitaVisualizzazione"
          :aggiornaDati="aggiornaDati" />
      </v-tab-item>

      <!-- Tab 3: Confronti -->
      <v-tab-item>
        <tab-confronti-ore :filtri="filtriGrafici" :modalita="modalitaVisualizzazione" :aggiornaDati="aggiornaDati" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { get_kpi_ore } from "@/api/api.clienti.js";
import TabAndamentoOre from "./TabAndamentoOre.vue";
import TabComposizioneOre from "./TabComposizioneOre.vue";
import TabConfrontiOre from "./TabConfrontiOre.vue";

export default {
  name: "DashboardOre",

  components: {
    TabAndamentoOre,
    TabComposizioneOre,
    TabConfrontiOre
  },

  data: () => ({
    tabAttiva: 0,
    aggiornaDati: 0,
    modalitaVisualizzazione: 'ore', // 'importi' o 'ore'

    filtriGrafici: {
      anno: new Date().getFullYear(),
      soloDaFatturare: true
    },

    anniDisponibili: [],

    schede: [
      {
        etichetta: 'Ore Totali',
        valore: '0',
        tendenza: 0,
        icona: 'schedule',
        colore: 'success'
      },
      {
        etichetta: 'Importo Totale',
        valore: '€ 0',
        tendenza: 0,
        icona: 'euro_symbol',
        colore: 'info'
      },
      {
        etichetta: 'Ore Medie Giornaliere',
        valore: '0',
        tendenza: 0,
        icona: 'analytics',
        colore: 'warning'
      },
      {
        etichetta: 'Clienti Attivi',
        valore: '0',
        tendenza: 0,
        icona: 'people',
        colore: 'primary lighten-5'
      }
    ]
  }),

  methods: {
    async caricaDatiKPI() {
      try {
        let res = await get_kpi_ore(this.filtriGrafici);
        if (res && res.data) {
          const dati = res.data;

          this.schede[0].valore = dati.oreTotali.toFixed(0);
          this.schede[0].tendenza = dati.tendenzaOre || 0;

          this.schede[1].valore = '€ ' + this.$functions.numberWithCommas(dati.importoTotale.toFixed(2));
          this.schede[1].tendenza = dati.tendenzaImporto || 0;

          this.schede[2].valore = dati.oreMediaGiornaliera.toFixed(2);
          this.schede[2].tendenza = dati.tendenzaMedia || 0;

          this.schede[3].valore = dati.clientiAttivi.toString();
          this.schede[3].tendenza = dati.tendenzaClienti || 0;
        }
      } catch (error) {
        console.error("Errore caricamento KPI:", error);
      }
    },

    caricaTuttiDati() {
      this.aggiornaDati++;
      this.caricaDatiKPI();
    },

    cambiaModalita() {
      // Forza aggiornamento dei grafici quando cambia modalità
      this.aggiornaDati++;
    },

    inizializzaAnni() {
      const annoCorrente = new Date().getFullYear();
      this.anniDisponibili = [];

      for (let i = 0; i < 6; i++) {
        this.anniDisponibili.push(annoCorrente - i);
      }
    }
  },

  mounted() {
    this.inizializzaAnni();
    this.caricaDatiKPI();
  },

  watch: {
    aggiornaDati() {
      this.caricaDatiKPI();
    }
  }
}
</script>